import React from "react";
import styles from "./RichTextView.scss";

export const RichTextView = React.memo(function RichTextView({ html }) {
    return <div className={styles.html} dangerouslySetInnerHTML={{ __html: html }}></div>;
});
